import { MainContent } from "./MainContent";

export const CardViewItem = (props: any) => <MainContent {...props} />;
